defineDs('DanskeSpil/Domain/Lotto/Scripts/Helpers/WednesdayLottoApi',
  [
    'Shared/Framework/Mithril/Scripts/Helpers/ApiRequest',
    'DanskeSpil/Domain/Lotto/Scripts/Helpers/LottoUtils'
  ],
  function (ApiRequest, LottoUtils) {

    // Variables:
    var baseURL = '/dlo/scapi/danskespil/numbergames/onsdagslotto';
    var baseJokerURL = '/dlo/scapi/danskespil/numbergames/jokerwednesday';

    // Functions:
    var prepareParamString = LottoUtils.prepareParamString;

    var getCompletedDrawDates = function (options) {
      var params = prepareParamString(options);

      return ApiRequest({
        url: baseURL + '/completedDrawDates' + params,
        localCacheTTL: 60,
        unwrapSuccess: function (response) {
          return response && response.drawDates ? response.drawDates : [];
        }
      });
    };

    var getWinningNumbersLotto = function (options) {
      var params = prepareParamString(options);

      return ApiRequest({
        url: baseURL + '/winningNumbers' + params,
        localCacheTTL: 60,
        unwrapSuccess: function (response) {
          return response;
        }
      });
    };

    var getRandomJokerNumbers = function (options) {
      var params = prepareParamString(options);

      return ApiRequest({
        url: baseJokerURL + '/random' + params,
        unwrapSuccess: function (response) {
          var rows = [];

          if (response && response.length > 0) {
            for (var i = 0; i < response.length; i++) {
              rows.push(response[i].split(''));
            }
          }

          return rows;
        }
      });
    };

    // Public functions:
    return {
      getCompletedDrawDates: getCompletedDrawDates,
      getWinningNumbersLotto: getWinningNumbersLotto,
      getRandomJokerNumbers: getRandomJokerNumbers,
    };

  });
